import React from 'react';
import PropTypes from 'prop-types';
import CountryProp from '../../../../commonComponents/forms/Address/CountryProp';

export default function CountryColumn({ country }) {
  const flag = country.flag ? country.flag.thumb : null;
  return (
    <div className="country-column">
      <div className="country-flag">
        {flag && <img src={flag} alt="country flag" />}
      </div>
      {country.name}
    </div>
  );
}

CountryColumn.propTypes = {
  country: PropTypes.shape(CountryProp.propType).isRequired,
};
